import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { toast } from "react-toastify";
import ReactAudioPlayer from "react-audio-player";
import settings from "utils/settings";
import { setAlert } from "actions/bike/actions";
import { Link } from "react-router-dom";

import AlertSound1 from "audio/alert1.mp3";
import AlertSound2 from "audio/alert2.mp3";

const { socketUrl } = settings;

const AlertWrapper = (props) => {
  const [playerSrc, setPlayerSrc] = useState(false);

  const subscribeUrl = "/alerts";
  const socketConnection = () => {
    const ws = new SockJS(socketUrl, null, {});
    const stompClient = Stomp.over(ws);
    stompClient.debug = () => false;
    stompClient.reconnect_delay = 3000;
    stompClient.heartbeat = {
      outgoing: 5000,
      incoming: 5000
    };
    stompClient.connect({}, () => {
      // frame
      stompClient.subscribe(subscribeUrl, (message) => {
        const alertInfo = JSON.parse(message.body);
        props.setAlert(alertInfo);
        let toastType = toast.TYPE.INFO,
          toastMessage = "Information";
        if (alertInfo.level === "WARN") {
          toastType = toast.TYPE.WARNING;
          toastMessage = "Warning";
        } else if (alertInfo.level === "CRITICAL") {
          toastType = toast.TYPE.ERROR;
          toastMessage = "Critical";
        }
        toast((
          <div className="d-block w-100 text-center">
            <h3>{toastMessage}</h3>
            <h4>
              Bike: <Link to={`/bikes/${alertInfo.bike.id}`} className="text-light"><u>{alertInfo.bike.id}</u></Link>
            </h4>
          </div>
        ), {
          type: toastType,
          autoClose: alertInfo.level === "INFO" ? 5000 : 30000,
          closeOnClick: true,
          position: toast.POSITION.BOTTOM_RIGHT,
          onClose: () => setPlayerSrc(false)
        });
        setPlayerSrc(false);
        if (alertInfo.level === "WARN" || alertInfo.level === "CRITICAL") {
          setPlayerSrc(AlertSound1);
        } else if (alertInfo.level === "INFO") {
          setPlayerSrc(AlertSound2);
        }
      }, {
        id: "bike-alerts"
      });
    }, () => {
      setTimeout(socketConnection, 3000);
    });
    return stompClient;
  };
  let stompClient;
  useEffect(() => {
    stompClient = socketConnection();
    return () => {
      stompClient.unsubscribe(subscribeUrl);
    };
  }, []);

  return (
    <div className="d-none">
      {playerSrc ?
        <ReactAudioPlayer
          src={playerSrc}
          autoPlay={true}
          controls={false}
          volume={0.5}
          onEnded={() => setPlayerSrc(false)}
        />
        : null}
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  setAlert: bindActionCreators(setAlert, dispatch)
});

export default connect(
  null,
  mapStateToDispatch
)(AlertWrapper);



// WEBPACK FOOTER //
// ./src/views/lib/components/alertWrapper.js